import React, { useEffect, useState } from "react";
import TableContainer from "@mui/material/TableContainer";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import AddCardIcon from "@mui/icons-material/AddCard";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import EditIcon from "@mui/icons-material/Edit";
import HistoryIcon from "@mui/icons-material/History";
import LockIcon from "@mui/icons-material/Lock";
import SearchIcon from "@mui/icons-material/Search";
import Paper from "@mui/material/Paper";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import "./Membertable.css";
import Swal from "sweetalert2";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { toast } from "react-toastify";
import MyTable from "./Table";
import { useLocation } from "react-router-dom";
import PasswordIcon from "@mui/icons-material/Password";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import XLSX from "xlsx-js-style";
import moment from "moment/moment";
import ApiConfig from "../../common/config/ApiConfig";
import { formatNumber } from "../../common/utils/helper";
import { useLanguage } from "../../common/i18n/LanguageContext";

// Fields known to hold plain numeric amounts/counts — only these get
// coerced to real numbers in the Agent list export, so an all-digit
// username never loses formatting (e.g. leading zeros) by becoming a
// number.
const NUMERIC_AGENT_ACCESSORS = new Set([
  "downline_count",
  "member_count",
  "credit",
]);

export default function CustomizedTables(props) {
  const { t, lang } = useLanguage();
  const [member, setMember] = useState([]);
  const [memberfilter, setMemberfilter] = useState([]);
  const [userid, setUserid] = useState([]);
  const [reload, setReload] = useState(0);
  const user = localStorage.getItem("user");
  const positions = localStorage.getItem("position");
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const levelurl = searchParams.get("level");
  const username = searchParams.get("username");
  const seniorParam = searchParams.get("senior");
  const masterParam = searchParams.get("master");
  const agentParam = searchParams.get("agent");

  // Drill-down breadcrumb (e.g. "MS01 \ MS0101 \ MS010101") — one crumb per
  // level already drilled into via the username link below, so clicking
  // deeper into senior -> master -> agent -> member keeps the path visible
  // and clickable back up. Mirrors Table.jsx's MyTable, which this page's
  // Agent list no longer renders through.
  const drillDownCrumbs = [];
  if (seniorParam) {
    drillDownCrumbs.push({
      label: seniorParam,
      href: `/agent?username=${seniorParam}&level=master&senior=${seniorParam}`,
    });
  }
  if (masterParam) {
    drillDownCrumbs.push({
      label: masterParam,
      href: `/agent?username=${masterParam}&level=agent&senior=${seniorParam}&master=${masterParam}`,
    });
  }
  if (agentParam) {
    drillDownCrumbs.push({
      label: agentParam,
      href: `/member?username=${agentParam}&level=member&senior=${seniorParam}&master=${masterParam}&agent=${agentParam}`,
    });
  }

  const subuserid = localStorage.getItem("subuserid");
  const [permission, setPermission] = useState({
    agent_credit_update: 1,
    edit_agent: 1,
    add_agent: 1,
  });
  const permissionGet = () => {
    ApiConfig.get(`/getpermissionid?id=${encodeURIComponent(subuserid)}`).then(
      (result) => {
        if (result.resCode !== 200) {
          toast.error(result.message || t("common_load_error"), {
            position: "top-right",
            autoClose: 3000,
          });
          return;
        }
        if (positions === "sub_account") {
          setPermission(result.data);
        }
      },
    );
  };

  const MemberGet = async () => {
    const params = new URLSearchParams({
      username: username ?? user,
      position: levelurl,
    });
    const result = await ApiConfig.get(`/admindetail?${params.toString()}`);
    if (result.resCode !== 200) {
      toast.error(result.message, {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }
    setMember(result.data);
    if (levelurl === "all") {
      setMemberfilter(result.data);
    } else {
      setMemberfilter(
        result.data.filter((element) => element.position === levelurl),
      );
    }
  };
  useEffect(() => {
    MemberGet();
    permissionGet();
    // eslint-disable-next-line
  }, [reload]);

  useEffect(() => {
    if (levelurl === "all") {
      console.log(levelurl);
      setMemberfilter(member);
    } else {
      const filteredArray = member.filter(
        (element) => element.position === levelurl,
      );
      setMemberfilter(filteredArray);
    }
    // eslint-disable-next-line
  }, [levelurl]);
  //////////////////////// redirect to edit agent page ////////////////////

  const handleDeleteagent = (agent) => {
    if (permission.edit_agent === 1) {
      // Show confirmation dialog
      Swal.fire({
        title: t("membertable_delete_confirm_title"),
        text: `${t("subaccount_delete_confirm_text_prefix")} ${agent}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("common_yes"),
        cancelButtonText: t("common_no"),
      }).then((result) => {
        if (result.isConfirmed) {
          // Delete the agent
          const jsonid = {
            username: agent,
          };
          ApiConfig.post("/deleteagent", jsonid)
            .then((result) => {
              if (result.resCode !== 200) {
                toast.error(result.message || t("common_delete_error"));
                return;
              }
              toast.success(t("membertable_delete_success"));
              window.location.reload();
            })
            .catch(() => {
              toast.error(t("common_delete_error"));
            });
        }
      });
    } else {
      alert(t("common_no_permission"));
    }
  };

  // Table's lock cell — click anywhere on the cell to toggle, regardless of
  // whether the icon is currently shown (it only shows while locked).
  const handleToggleAgentLock = (agent, isLocked) => {
    if (permission.edit_agent !== 1) {
      alert(t("common_no_permission"));
      return;
    }
    Swal.fire({
      title: t("agent_lock_confirm_title"),
      text: isLocked
        ? t("agent_lock_confirm_text_unlock")
        : t("agent_lock_confirm_text_lock"),
      icon: "warning",
      iconHtml: isLocked ? "🔓" : "🔒",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("common_yes"),
      cancelButtonText: t("common_no"),
    }).then((result) => {
      if (!result.isConfirmed) return;
      ApiConfig.put(`/updateagent/lock/${agent}`, { lock: !isLocked })
        .then((res) => {
          if (res.resCode !== 200) {
            toast.error(res.message || t("agent_lock_error"), {
              autoClose: 2000,
            });
            return;
          }
          toast.success(t("agent_lock_success"), { autoClose: 2000 });
          setReload(reload + 1);
        })
        .catch(() => {
          toast.error(t("agent_lock_error"), { autoClose: 2000 });
        });
    });
  };

  // Table's status cell — click to open a select dropdown of the 3 status
  // values. Switching to "inactive" gets its own extra confirm on top of
  // the picker, since that permanently zeroes this agent's AND every
  // downline user's commission/payrate (see zeroDownlineCommissionAndPayrateCascade
  // in member.service.ts) — not reversible by switching back to "active".
  const handleEditAgentStatus = (agent, currentStatus) => {
    if (permission.edit_agent !== 1) {
      alert(t("common_no_permission"));
      return;
    }
    Swal.fire({
      title: t("agent_status_confirm_title"),
      input: "select",
      inputOptions: {
        active: t("agentadd_status_active"),
        inactive: t("agentadd_status_inactive"),
        suspend: t("agentadd_status_suspend"),
      },
      inputValue: currentStatus,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("common_yes"),
      cancelButtonText: t("common_no"),
    }).then((result) => {
      if (!result.isConfirmed) return;
      const newStatus = result.value;
      if (!newStatus || newStatus === currentStatus) return;

      const applyStatus = () => {
        ApiConfig.put(`/updateagent/status/${agent}`, { status: newStatus })
          .then((res) => {
            if (res.resCode !== 200) {
              toast.error(res.message || t("agent_lock_error"), {
                autoClose: 2000,
              });
              return;
            }
            toast.success(t("agent_lock_success"), { autoClose: 2000 });
            setReload(reload + 1);
          })
          .catch(() => {
            toast.error(t("agent_lock_error"), { autoClose: 2000 });
          });
      };

      if (newStatus === "inactive") {
        Swal.fire({
          icon: "warning",
          title: t("agent_status_inactive_warning_title"),
          text: t("agent_status_inactive_warning_text"),
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: t("common_yes"),
          cancelButtonText: t("common_no"),
        }).then((confirmResult) => {
          if (confirmResult.isConfirmed) applyStatus();
        });
      } else {
        applyStatus();
      }
    });
  };

  const handlecredit = async (memberuser, rowid, value) => {
    let inputValue = value;
    let update = await parseInt(inputValue);
    let useradmin = localStorage.getItem("user");
    const byAgent = searchParams.get("username");
    const jsonid = {
      adminusername: byAgent ?? useradmin,
      updateamout: update,
      username: memberuser,
    };

    if (permission.agent_credit_update === 1) {
      // Check if input field is empty
      if (!inputValue || isNaN(update)) {
        Swal.fire({
          icon: "error",
          title: t("common_oops"),
          text: t("agent_credit_amount_required"),
        });
        return;
      }

      Swal.fire({
        title: t("agent_credit_confirm_title"),
        text: `${t("agent_credit_confirm_text_prefix")} ${update} ${t("agent_credit_confirm_text_middle")} ${memberuser}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("common_yes"),
        cancelButtonText: t("common_no"),
      }).then((result) => {
        if (result.isConfirmed) {
          ApiConfig.post("/updateagentcredit", jsonid)
            .then((res) => {
              if (res.resCode !== 200) {
                Swal.fire({
                  icon: "error",
                  title: t("common_oops"),
                  text: t("agent_credit_insufficient"),
                });
              } else {
                setReload(reload + 1);
                // The Downline dialog's rows come from a one-off
                // /getdownline fetch (handleClickOpendownline), not from
                // `reload` — refetch it too so its credit column doesn't
                // go stale if the dialog is open when a credit update
                // happens inside it.
                if (opendownline && downlineof) {
                  ApiConfig.get(
                    `/getdownline?user=${encodeURIComponent(downlineof)}`,
                  ).then((result) => {
                    if (result.resCode === 200) {
                      setDownline(result.data);
                    }
                  });
                }
              }
            })
            .catch(() => {
              Swal.fire({
                icon: "error",
                title: t("common_oops"),
                text: t("common_generic_error"),
              });
            });
        }
      });
    } else {
      alert(t("common_no_permission"));
    }
  };

  const [openAddCredit, setOpenAddCredit] = React.useState(false);
  const [creditTarget, setCreditTarget] = useState(null);
  const [creditAmount, setCreditAmount] = useState("");
  const [currencyCodeById, setCurrencyCodeById] = useState({});

  useEffect(() => {
    ApiConfig.get("/getCurrencyList").then((result) => {
      if (result.resCode !== 200) return;
      const list = Array.isArray(result.data) ? result.data : [];
      setCurrencyCodeById(Object.fromEntries(list.map((c) => [c.id, c.code])));
    });
  }, []);

  // mode ("add" | "remove") comes from which button on the table was
  // pressed, so the dialog itself only needs a single confirm button.
  const handleOpenAddCredit = (username, id, mode = "add") => {
    setCreditTarget({ username, id, mode });
    setCreditAmount("");
    setOpenAddCredit(true);
  };

  const handleCloseAddCredit = () => {
    setOpenAddCredit(false);
    setCreditTarget(null);
    setCreditAmount("");
  };

  const handleSubmitAddCredit = () => {
    if (!creditTarget) return;
    const multiplier = creditTarget.mode === "remove" ? -1 : 1;
    handlecredit(
      creditTarget.username,
      creditTarget.id,
      creditAmount * multiplier,
    );
    handleCloseAddCredit();
  };

  const [transactiom, setTransaction] = useState([]);
  const [opentransaction, setOpentransaction] = React.useState(false);

  const handleClosetransaction = () => {
    setOpentransaction(false);
  };
  const gettransaction = (agent) => {
    const positionget = {
      user: agent,
    };
    ApiConfig.post("/gettransaction", positionget).then((result) => {
      if (result.resCode !== 200) {
        toast.error(result.message || t("common_load_error"), {
          position: "top-right",
          autoClose: 3000,
        });
        return;
      }
      setTransaction(Array.isArray(result.data) ? result.data : []);
      setOpentransaction(true);
    });
  };

  // #region password edit

  const [password, setPassword] = useState();
  const [openeditpassword, setOpeneditpassword] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleClickOpenpassword = (username) => {
    console.log("=======username=======", username);
    if (permission.edit_agent === 1) {
      setUserid(username);
      setOpeneditpassword(true);
    } else {
      alert(t("common_no_permission"));
    }
  };

  const handleClosepassword = () => {
    setOpeneditpassword(false);
    setUserid();
  };

  const handleChangepassword = (event) => {
    setPassword(event.target.value);
  };
  const handleUpdatepassword = (password) => {
    const jsonid = {
      Username: userid,
      Password: password,
    };

    Swal.fire({
      title: t("membertable_change_password_title"),
      text: t("membertable_change_password_text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("common_confirm"),
      cancelButtonText: t("common_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        // User confirmed the action, proceed with the fetch
        ApiConfig.post("/passwordchange", jsonid)
          .then((result) => {
            if (result.resCode !== 200) {
              toast.error(
                result.message || t("membertable_change_password_error"),
                {
                  position: "top-right",
                  autoClose: 3000,
                },
              );
              return;
            }
            toast.success(t("membertable_change_password_success"), {
              position: "top-right",
              autoClose: 3000,
            });
          })
          .catch(() => {
            toast.error(t("membertable_change_password_error"), {
              position: "top-right",
              autoClose: 3000,
            });
          });
      }
    });

    handleClosepassword(); // Close the password dialog regardless of the user's choice
  };

  // #endregion

  // #region downline show

  const [opendownline, setOpendownline] = React.useState(false);
  const [downline, setDownline] = useState([]);
  const [downlineof, setDownlineof] = useState();
  const handleClickOpendownline = (username, value) => {
    setDownlineof(username);

    if (permission.edit_agent === 1) {
      if (value > 0) {
        ApiConfig.get(`/getdownline?user=${encodeURIComponent(username)}`).then(
          (result) => {
            if (result.resCode !== 200) {
              toast.error(result.message || t("common_load_error"), {
                position: "top-right",
                autoClose: 3000,
              });
              return;
            }
            setDownline(result.data);
            setOpendownline(true);
          },
        );
      } else {
        toast.error(t("agent_no_downline"));
      }
    } else {
      alert(t("common_no_permission"));
    }
  };

  const handleClosedownline = () => {
    setOpendownline(false);
    setUserid();
  };

  // #endregion
  const Downlinecolumns = [
    {
      Header: t("membertable_col_no"),
      align: "center",
      widthClass: "w-[50px]",
      width: 50,
      Cell: ({ row }) => (
        <span className="font-bold text-[9px] md:text-[11px]">
          {row.index + 1}
        </span>
      ),
    },
    {
      Header: t("agent_col_agent_username"),
      accessor: "username",
      fitContent: true,
      Cell: ({ value }) => (
        <span className="font-bold text-[9px] md:text-[11px]">{value}</span>
      ),
    },
    {
      Header: t("agent_col_position"),
      accessor: "position",
      align: "right",
      fitContent: true,
      Cell: ({ value }) => {
        let colorClass = "bg-slate-100 text-slate-800";
        if (value === "agent") {
          colorClass = "bg-sky-100 text-sky-800";
        }
        if (value === "senior") {
          colorClass = "bg-green-100 text-green-800";
        }
        if (value === "master") {
          colorClass = "bg-yellow-100 text-yellow-900";
        }
        if (value === "company") {
          colorClass = "bg-brand-blue-100 text-brand-blue-800";
        }
        return (
          <div className="text-center">
            <span
              className={`inline-block px-2 py-0.5 rounded-full font-semibold text-[9px] md:text-[11px] ${colorClass}`}
            >
              {value}
            </span>
          </div>
        );
      },
    },
    {
      Header: t("agent_col_upline"),
      accessor: "upline_username",
      align: "right",
      fitContent: true,
      Cell: ({ value }) => (
        <span className="font-bold text-[9px] md:text-[11px]">{value}</span>
      ),
    },
    {
      Header: t("agent_col_total_downline"),
      accessor: "downline_count",
      align: "right",
      fitContent: true,
      Cell: ({ value }) => {
        const floatValue = parseFloat(value);
        let textColorClass = "text-slate-400"; // Default to black

        if (floatValue > 0) {
          textColorClass = "text-sky-600"; // Change to green for positive values
        } else if (floatValue < 0) {
          textColorClass = "text-red-600"; // Change to red for negative values
        }

        return (
          <span
            className={`font-bold text-[9px] md:text-[11px] ${textColorClass}`}
          >
            {floatValue}
          </span>
        );
      },
    },
    {
      Header: t("agent_col_total_member"),
      accessor: "member_count",
      align: "right",
      fitContent: true,
      Cell: ({ value }) => {
        const floatValue = parseFloat(value);
        let textColorClass = "text-slate-400"; // Default to black

        if (floatValue > 0) {
          textColorClass = "text-sky-600"; // Change to green for positive values
        } else if (floatValue < 0) {
          textColorClass = "text-red-600"; // Change to red for negative values
        }

        return (
          <span
            className={`font-bold text-[9px] md:text-[11px] ${textColorClass}`}
          >
            {floatValue}
          </span>
        );
      },
    },
    {
      Header: t("agent_col_credit"),
      accessor: "credit",
      align: "right",
      fitContent: true,
      Cell: ({ row, value }) => {
        const floatValue = parseFloat(value).toFixed(2);
        let textColorClass = "text-slate-400"; // Default to black

        if (floatValue > 0) {
          textColorClass = "text-green-600"; // Change to green for positive values
        } else if (floatValue < 0) {
          textColorClass = "text-red-600"; // Change to red for negative values
        }

        return (
          <>
            <span
              className={`font-bold text-[9px] md:text-[11px] ${textColorClass}`}
            >
              {/* {floatValue.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} */}
              {formatNumber(floatValue, 2)}{" "}
              {currencyCodeById[row.original.currency_id]}
            </span>
            <div>{t("agent_col_credit_history")}</div>
          </>
        );
      },
    },
    {
      Header: t("agent_col_add_remove_credit"),
      align: "right",
      fitContent: true,
      Cell: ({ row }) => (
        <button
          onClick={() =>
            handleOpenAddCredit(row.original.username, row.original.id)
          }
          className="bg-green-500 text-white hover:bg-green-700 p-1 rounded flex items-center justify-center"
        >
          <AddCardIcon sx={{ fontSize: 16 }} />
        </button>
      ),
    },
    {
      Header: t("agent_col_edit_data"),
      align: "center",
      fitContent: true,
      Cell: ({ row }) => (
        <div className="flex flex-row items-center space-x-1">
          <button className="bg-blue-400 text-white hover:bg-slate-600 hover:text-black p-1 rounded flex items-center justify-center">
            <a
              href={`/agentedit?username=${row.original.username}&position=${row.original.position}&uplineusername=${row.original.upline_username}&level=${row.original.position}&status=${row.original.status}&lock=${row.original.lock}&currency_id=${row.original.currency_id}`}
              className="text-white no-underline flex items-center"
            >
              <EditIcon sx={{ fontSize: 16 }} />
            </a>
          </button>
          <button
            onClick={() => handleClickOpenpassword(row.original.username)}
            className="bg-yellow-400 text-white hover:bg-slate-600 hover:text-black p-1 rounded flex items-center justify-center"
          >
            <PasswordIcon sx={{ fontSize: 16 }} />
          </button>
          <button
            onClick={() => handleDeleteagent(row.original.username)}
            className="bg-red-400 text-white hover:bg-slate-600 hover:text-black p-1 rounded flex items-center justify-center"
          >
            <DeleteForeverIcon sx={{ fontSize: 16 }} />
          </button>
        </div>
      ),
    },
  ];

  const level =
    levelurl === "senior"
      ? "master"
      : levelurl === "master"
        ? "agent"
        : "member";
  const Agentcolumns = [
    {
      Header: t("membertable_col_no"),
      align: "center",
      widthClass: "w-[50px]",
      width: 50,
      Cell: ({ row }) => (
        <span className="font-bold text-[9px] md:text-[11px]">
          {row.index + 1}
        </span>
      ),
    },
    {
      Header:
        lang === "th"
          ? `${t("login_username_label")} ${levelurl}`
          : `${levelurl} ${t("login_username_label")}`,
      accessor: "username",
      Cell: ({ value, row }) => {
        const nextParams = new URLSearchParams();
        if (levelurl === "senior") {
          nextParams.set("senior", value);
        } else if (levelurl === "master") {
          if (seniorParam) nextParams.set("senior", seniorParam);
          nextParams.set("master", value);
        } else if (levelurl === "agent") {
          if (seniorParam) nextParams.set("senior", seniorParam);
          if (masterParam) nextParams.set("master", masterParam);
          nextParams.set("agent", value);
        }
        nextParams.set("username", value);
        nextParams.set("level", level);

        return (
          <a
            href={
              level === "member"
                ? `/member?${nextParams.toString()}`
                : `/agent?${nextParams.toString()}`
            }
            className="font-bold text-[9px] md:text-[11px]"
          >
            <u className="text-blue-600">{value}</u>
          </a>
        );
      },
    },
    {
      Header: t("agent_col_position"),
      accessor: "position",
      align: "center",
      Cell: ({ value }) => {
        let colorClass = "bg-slate-100 text-slate-800";
        if (value === "agent") {
          colorClass = "bg-sky-100 text-sky-800";
        }
        if (value === "senior") {
          colorClass = "bg-green-100 text-green-800";
        }
        if (value === "master") {
          colorClass = "bg-yellow-100 text-yellow-900";
        }
        if (value === "company") {
          colorClass = "bg-brand-blue-100 text-brand-blue-800";
        }
        return (
          <div className="text-center">
            <span
              className={`inline-block px-2 py-0.5 rounded-full font-semibold text-[9px] md:text-[11px] ${colorClass}`}
            >
              {value}
            </span>
          </div>
        );
      },
    },
    {
      Header: t("agent_col_upline"),
      accessor: "upline_username",
      align: "right",
      Cell: ({ value }) => (
        <span className="font-bold text-[9px] md:text-[11px]">{value}</span>
      ),
    },
    {
      Header: t("agent_col_total_downline"),
      accessor: "downline_count",
      align: "right",
      Cell: ({ value, row }) => {
        const intValue = parseInt(value, 10);
        let textColorClass = "text-slate-400"; // Default to black
        let bgColorClass = "bg-amber-200";

        if (intValue > 0) {
          textColorClass = "text-slate-700"; // Change to green for positive values
          bgColorClass = "bg-amber-300";
        } else if (intValue <= 0) {
          textColorClass = "text-red-500"; // Change to red for negative values
          bgColorClass = "bg-slate-300";
        }

        return (
          <div className="flex space-x-2 flex-row">
            <div
              className={`font-bold text-[9px] md:text-[11px] ${bgColorClass} ${textColorClass} rounded-lg border-1 border-black px-2 pt-1`} // Add rounded-md for a rounded border
            >
              {value}
              {t("agent_person_unit") ? ` ${t("agent_person_unit")}` : ""}
            </div>
            <button
              onClick={() =>
                handleClickOpendownline(row.original.username, intValue)
              }
              className="text-slate-600 no-underline hover:text-slate-800"
            >
              <SearchIcon />
            </button>
          </div>
        );
      },
    },
    {
      Header: t("agent_col_total_member"),
      accessor: "member_count",
      align: "right",
      Cell: ({ value }) => {
        const floatValue = parseFloat(value);
        let textColorClass = "text-slate-400"; // Default to black

        if (floatValue > 0) {
          textColorClass = "text-sky-600"; // Change to green for positive values
        } else if (floatValue < 0) {
          textColorClass = "text-red-600"; // Change to red for negative values
        }

        return (
          <span
            className={`font-bold text-[9px] md:text-[11px] ${textColorClass}`}
          >
            {floatValue}
            {t("agent_person_unit") ? ` ${t("agent_person_unit")}` : ""}
          </span>
        );
      },
    },
    {
      Header: t("agent_col_credit"),
      accessor: "credit",
      align: "right",
      Cell: ({ row, value }) => {
        const floatValue = parseFloat(value);
        let textColorClass = "text-slate-400"; // Default to black

        if (floatValue > 0) {
          textColorClass = "text-green-600"; // Change to green for positive values
        } else if (floatValue < 0) {
          textColorClass = "text-red-600"; // Change to red for negative values
        }

        return (
          <div className="flex flex-row items-center justify-end space-x-1">
            <span
              className={`font-bold text-[9px] md:text-[11px] ${textColorClass}`}
            >
              {floatValue.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}{" "}
              {currencyCodeById[row.original.currency_id]}
            </span>
            <button
              onClick={() => gettransaction(row.original.username)}
              className="text-slate-600 no-underline hover:text-slate-800 flex items-center"
            >
              <HistoryIcon sx={{ fontSize: 16 }} />
            </button>
            <button
              onClick={() =>
                handleOpenAddCredit(
                  row.original.username,
                  row.original.id,
                  "add",
                )
              }
              title={t("agent_add_credit_title")}
              className="bg-green-500 text-white hover:bg-green-700 p-1 rounded flex items-center justify-center"
            >
              <AddCircleIcon sx={{ fontSize: 16 }} />
            </button>
            <button
              onClick={() =>
                handleOpenAddCredit(
                  row.original.username,
                  row.original.id,
                  "remove",
                )
              }
              title={t("agent_remove_credit_title")}
              className="bg-red-500 text-white hover:bg-red-700 p-1 rounded flex items-center justify-center"
            >
              <RemoveCircleIcon sx={{ fontSize: 16 }} />
            </button>
          </div>
        );
      },
    },
    {
      Header: t("agent_col_status"),
      accessor: "status",
      align: "center",
      Cell: ({ value, row }) => {
        let colorClass = "bg-slate-100 text-slate-800";
        let label = value;
        if (value === "active") {
          colorClass = "bg-green-100 text-green-800";
          label = t("agentadd_status_active");
        } else if (value === "inactive") {
          colorClass = "bg-slate-200 text-slate-700";
          label = t("agentadd_status_inactive");
        } else if (value === "suspend") {
          colorClass = "bg-red-100 text-red-800";
          label = t("agentadd_status_suspend");
        }
        return (
          <button
            type="button"
            onClick={() => handleEditAgentStatus(row.original.username, value)}
            className="w-full text-center"
          >
            <span
              className={`inline-block px-2 py-0.5 rounded-full font-semibold text-[9px] md:text-[11px] cursor-pointer hover:brightness-95 ${colorClass}`}
            >
              {label}
            </span>
          </button>
        );
      },
    },
    {
      Header: t("agent_col_lock"),
      accessor: "lock",
      align: "center",
      Cell: ({ value, row }) => {
        const isLocked = value === true || value === 1 || value === "1";
        return (
          <button
            type="button"
            onClick={() =>
              handleToggleAgentLock(row.original.username, isLocked)
            }
            className="w-full flex items-center justify-center text-red-600 hover:text-red-800 py-1"
          >
            {/* Icon always renders so the button keeps a real clickable
                size — `invisible` only hides it visually, it still reserves
                its box, unlike conditionally not rendering it at all. */}
            <LockIcon
              sx={{ fontSize: 18 }}
              className={isLocked ? "" : "invisible"}
            />
          </button>
        );
      },
    },
    {
      Header: t("agent_col_edit_data"),
      align: "center",
      Cell: ({ row }) => (
        <div className="flex flex-row items-center space-x-1">
          <button className="bg-blue-400 text-white hover:bg-slate-600 hover:text-black p-1 rounded flex items-center justify-center">
            <a
              href={`/agentedit?username=${row.original.username}&position=${row.original.position}&uplineusername=${row.original.upline_username}&level=${row.original.position}&name=${row.original.name}&tel=${row.original.tel}&email=${row.original.email}&status=${row.original.status}&lock=${row.original.lock}&currency_id=${row.original.currency_id}`}
              className="text-white no-underline flex items-center"
            >
              <EditIcon sx={{ fontSize: 16 }} />
            </a>
          </button>
          <button
            onClick={() => handleClickOpenpassword(row.original.username)}
            className="bg-yellow-400 text-white hover:bg-slate-600 hover:text-black p-1 rounded flex items-center justify-center"
          >
            <PasswordIcon sx={{ fontSize: 16 }} />
          </button>
          <button
            onClick={() => handleDeleteagent(row.original.username)}
            className="bg-red-400 text-white hover:bg-slate-600 hover:text-black p-1 rounded flex items-center justify-center"
          >
            <DeleteForeverIcon sx={{ fontSize: 16 }} />
          </button>
        </div>
      ),
    },
  ];

  // Agentcolumns is rendered as a plain <table> below instead of through
  // MyTable/react-table — MUI's <Table> forces width:100% on its root
  // regardless of className, and once every column is content-sized that
  // leaves no flexible column to absorb the leftover width, so auto table
  // layout spreads it evenly across all of them instead of shrinking. A
  // native table with no width forced on it just sizes to its content.
  const [agentSearchName, setAgentSearchName] = useState("");
  const [agentSearchUpline, setAgentSearchUpline] = useState("");
  const [filteredAgentRows, setFilteredAgentRows] = useState([]);
  const [exportingAgents, setExportingAgents] = useState(false);

  useEffect(() => {
    setFilteredAgentRows(Array.isArray(memberfilter) ? memberfilter : []);
  }, [memberfilter]);

  const handleSearchAgentClick = () => {
    const filtered = (Array.isArray(memberfilter) ? memberfilter : []).filter(
      (item) => {
        const matchName =
          agentSearchName === "" || item.username?.includes(agentSearchName);
        const matchUpline =
          agentSearchUpline === "" ||
          item.upline_username?.includes(agentSearchUpline);
        return matchName && matchUpline;
      },
    );
    setFilteredAgentRows(filtered);
  };

  // Reads header text + raw values straight from Agentcolumns (any column
  // without an accessor is a rendered-only control — row number, action
  // buttons — and is skipped), same approach as Table.jsx's generic export.
  const handleExportAgentExcel = () => {
    if (filteredAgentRows.length === 0) {
      toast.info(t("common_no_data"), { autoClose: 2000 });
      return;
    }
    setExportingAgents(true);
    try {
      const exportColumns = Agentcolumns.filter((col) => col.accessor);
      const header = exportColumns.map((col) => col.Header);
      const dataRows = filteredAgentRows.map((item) =>
        exportColumns.map((col) => {
          const raw = item[col.accessor];
          if (raw === null || raw === undefined || raw === "") return "";
          if (NUMERIC_AGENT_ACCESSORS.has(col.accessor)) {
            const num = Number(raw);
            if (!isNaN(num)) return num;
          }
          return raw;
        }),
      );
      const worksheet = XLSX.utils.aoa_to_sheet([header, ...dataRows]);
      worksheet["!cols"] = exportColumns.map(() => ({ wch: 16 }));
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Agent");
      XLSX.writeFile(
        workbook,
        `agent-list-${moment().format("YYYYMMDD_HHmm")}.xlsx`,
      );
    } catch (error) {
      toast.error(t("common_load_error"), { autoClose: 2000 });
    } finally {
      setExportingAgents(false);
    }
  };

  const transactioncolumns = [
    {
      Header: t("membertable_col_no"),
      accessor: "id",
      align: "center",
      widthClass: "w-[50px]",
      width: 50,
      Cell: ({ row }) => (
        <span className="font-bold text-[9px] md:text-[11px]">
          {row.index + 1}
        </span>
      ),
    },
    {
      Header: t("membertable_tx_col_date"),
      accessor: "date_time",
      align: "right",
      fitContent: true,
      Cell: ({ value }) => {
        let textColorClass = "text-black";
        let bgColorClass = "bg-amber-200";

        return (
          <div className="flex space-x-2 flex-row">
            <div
              className={`font-bold text-[9px] md:text-[11px] ${bgColorClass} ${textColorClass} rounded-lg border-1 border-black px-2 pt-1`} // Add rounded-md for a rounded border
            >
              {moment(value).format("DD/MM/YYYY HH:mm")}
            </div>
          </div>
        );
      },
    },
    {
      Header: t("membertable_tx_col_sender"),
      accessor: "Sender",
      fitContent: true,
      Cell: ({ value }) => (
        <span className="font-bold text-[9px] md:text-[11px]">{value}</span>
      ),
    },
    {
      Header: t("membertable_tx_col_receiver"),
      accessor: "Reciever",
      align: "right",
      fitContent: true,
      Cell: ({ value }) => (
        <span className="font-bold text-[9px] md:text-[11px]">{value}</span>
      ),
    },
    {
      Header: t("membertable_tx_col_amount"),
      accessor: "Amout",
      align: "center",
      fitContent: true,
      Cell: ({ value }) => {
        const floatValue = parseFloat(value);
        let textColorClass = "text-slate-400"; // Default to black

        if (floatValue > 0) {
          textColorClass = "text-green-600"; // Change to green for positive values
        } else if (floatValue < 0) {
          textColorClass = "text-red-600"; // Change to red for negative values
        }

        return (
          <span
            className={`font-bold text-[9px] md:text-[11px] ${textColorClass}`}
          >
            {floatValue.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        );
      },
    },
    {
      Header: t("membertable_tx_col_ip"),
      accessor: "ip",
      fitContent: true,
      Cell: ({ value }) => (
        <span className="font-bold text-[9px] md:text-[11px]">
          {value ?? "-"}
        </span>
      ),
    },
    {
      Header: t("membertable_tx_col_device"),
      accessor: "device",
      Cell: ({ value }) => (
        <span
          className="text-[9px] md:text-[11px] truncate block max-w-[160px]"
          title={value ?? ""}
        >
          {value ?? "-"}
        </span>
      ),
    },
  ];

  return (
    <div>
      <TableContainer component={Paper}>
        <div className="p-2 bg-amber-50 border-[1px] border-slate-400 rounded-lg">
          <div className="p-2 flex items-center">
            <div className="flex flex-row items-center mr-4">
              <p className="font-bold mr-2 text-xs">
                {t("table_search_agent_name")}
              </p>
              <input
                type="text"
                className="p-1 border border-gray-300 rounded text-xs"
                value={agentSearchName}
                onChange={(e) => setAgentSearchName(e.target.value)}
              />
            </div>
            <div className="flex flex-row items-center">
              <p className="font-bold mr-2 text-xs">
                {t("table_search_upline_name")}
              </p>
              <input
                type="text"
                className="p-1 border border-gray-300 rounded text-xs"
                value={agentSearchUpline}
                onChange={(e) => setAgentSearchUpline(e.target.value)}
              />
            </div>
            <button
              onClick={handleSearchAgentClick}
              className="py-1 px-2 bg-blue-500 text-white rounded text-xs"
            >
              {t("table_search_button")}
            </button>
            <button
              onClick={handleExportAgentExcel}
              disabled={exportingAgents}
              className="flex items-center gap-1 py-1 px-2 ml-2 bg-green-600 text-white rounded text-xs disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <FileDownloadIcon sx={{ fontSize: 16 }} />
              {exportingAgents
                ? t("common_exporting")
                : t("common_export_excel")}
            </button>
          </div>
        </div>
        {drillDownCrumbs.length > 0 && (
          <div className="px-2 py-1 text-sm font-semibold text-brand-blue-700 flex flex-wrap items-center gap-1">
            {drillDownCrumbs.map((crumb, index) => (
              <React.Fragment key={crumb.href}>
                {index > 0 && <span className="text-brand-blue-400">\</span>}
                <a href={crumb.href} className="hover:underline">
                  {crumb.label}
                </a>
              </React.Fragment>
            ))}
          </div>
        )}
        <div className="overflow-x-auto mt-1">
          <table className="w-full text-[14px]">
            <thead>
              <tr className="bg-gray-100">
                {Agentcolumns.map((col, idx) => (
                  <th
                    key={col.accessor ?? `agent-col-${idx}`}
                    className="py-1 px-2 text-[14px] whitespace-nowrap"
                    align={col.align}
                  >
                    {col.Header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredAgentRows.map((item, index) => (
                <tr
                  key={item.id ?? item.username ?? index}
                  className={`transition-colors ${
                    index % 2 === 0 ? "bg-gray-50" : "bg-gray-200"
                  } hover:bg-gray-300`}
                >
                  {Agentcolumns.map((col, colIdx) => {
                    const row = { original: item, index };
                    const value = col.accessor ? item[col.accessor] : undefined;
                    return (
                      <td
                        key={col.accessor ?? `agent-cell-${colIdx}`}
                        className="py-1 px-2 whitespace-nowrap"
                        align={col.align}
                      >
                        {col.Cell ? col.Cell({ value, row }) : value}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </TableContainer>
      {/* edit agent */}
      {/* edit password */}
      {openeditpassword && (
        <div>
          <Dialog
            open={openeditpassword}
            onClose={handleClosepassword}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              style: { width: "60%", maxWidth: "100%", margin: 0 },
            }}
          >
            <DialogTitle
              className="text-white bg-brand-blue-800"
              id="alert-dialog-title"
            >
              {t("membertable_change_password_dialog_title_prefix")} {userid}
            </DialogTitle>
            <DialogContent>
              <div className="flex w-full flex-col space-y-2">
                <div className="flex w-[100%] flex-col space-y-2 p-2 rounded-xl border border-[1px]">
                  {/* Content */}
                  <span>{t("membertable_new_password_prompt")}</span>

                  <FormControl sx={{ m: 1, width: "100%" }} variant="standard">
                    <InputLabel htmlFor="standard-adornment-password">
                      {t("login_password_label")}
                    </InputLabel>
                    <Input
                      id="standard-adornment-password"
                      type={showPassword ? "text" : "password"}
                      autoComplete="off"
                      onChange={(e) => handleChangepassword(e)}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </div>
              </div>
            </DialogContent>

            <DialogActions>
              <button
                onClick={() => handleUpdatepassword(password)}
                className="bg-gradient-to-b from-brand-gold-300 via-brand-gold-400 to-brand-gold-600 text-brand-ink-onGold border border-brand-gold-200 shadow-gold hover:brightness-105 font-bold py-2 px-4 mr-1 rounded"
              >
                <SaveAltIcon /> {t("membertable_save")}
              </button>
              <button
                onClick={handleClosepassword}
                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
              >
                {t("common_cancel")}
              </button>
            </DialogActions>
          </Dialog>
        </div>
      )}
      {/* downline show */}
      {opendownline && (
        <div>
          <Dialog
            open={opendownline}
            onClose={handleClosedownline}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              style: { width: "80%", maxWidth: "100%", margin: 0 },
            }}
          >
            <DialogTitle
              className="text-white bg-brand-blue-800"
              id="alert-dialog-title"
            >
              <div className="p-1 flex justify-items-center items-center flex-row space-x-2">
                <span>{t("agent_downline_list_title")}</span>
                <div className="pl-1 pr-1 border-1 bg-yellow-300 rounded-lg">
                  <span className="font-bold text-slate-700 text-[15px]">
                    {downlineof}
                  </span>
                </div>
              </div>
            </DialogTitle>
            <DialogContent>
              <div className="flex w-full flex-col space-y-2">
                <div className="flex w-[100%] flex-col space-y-2 p-2 rounded-xl border border-[1px]">
                  {/* Content */}
                  <MyTable
                    columns={Downlinecolumns}
                    data={downline}
                    autoWidth
                  />
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <button
                onClick={handleClosedownline}
                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
              >
                {t("common_cancel")}
              </button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {opentransaction && (
        <div>
          <Dialog
            open={opentransaction}
            onClose={handleClosetransaction}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              style: { width: "60%", maxWidth: "100%", margin: 0 },
            }}
          >
            <DialogTitle
              className="text-white bg-brand-blue-800"
              id="alert-dialog-title"
            >
              <div className="p-1 flex justify-items-center items-center flex-row space-x-2">
                <span>{t("membertable_credit_history_title")}</span>
                <div className="pl-1 pr-1 border-1 bg-yellow-400 rounded-lg drop-shadow-xl">
                  <span className="font-bold text-slate-700 text-[15px]">
                    {downlineof}
                  </span>
                </div>
              </div>
            </DialogTitle>
            <DialogContent>
              <div className="flex w-full flex-col space-y-2">
                <div className="flex w-[100%] flex-col space-y-2 p-2 rounded-xl border border-[1px]">
                  {/* Content */}
                  <MyTable
                    columns={transactioncolumns}
                    data={transactiom}
                    autoWidth
                  />
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <button
                onClick={handleClosetransaction}
                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
              >
                {t("common_cancel")}
              </button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {openAddCredit && (
        <div>
          <Dialog
            open={openAddCredit}
            onClose={handleCloseAddCredit}
            aria-labelledby="add-credit-dialog-title"
            PaperProps={{ style: { width: "360px", maxWidth: "100%" } }}
          >
            <DialogTitle
              className="text-white bg-brand-blue-800"
              id="add-credit-dialog-title"
            >
              {creditTarget?.mode === "remove"
                ? t("agent_remove_credit_title")
                : t("agent_add_credit_title")}{" "}
              : {creditTarget?.username}
            </DialogTitle>
            <DialogContent>
              <div className="flex flex-col space-y-3 pt-3">
                <label className="text-gray-700 font-bold">
                  {t("membertable_credit_amount_label")}
                </label>
                <input
                  type="number"
                  min="0"
                  step={100}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-brand-blue-500"
                  value={creditAmount}
                  onChange={(e) => setCreditAmount(e.target.value)}
                  placeholder={t("membertable_credit_amount_placeholder")}
                />
              </div>
            </DialogContent>
            <DialogActions>
              <button
                onClick={handleSubmitAddCredit}
                className="bg-brand-blue-600 hover:bg-brand-blue-700 text-white font-bold py-2 px-4 rounded"
              >
                {t("common_ok")}
              </button>
              <button
                onClick={handleCloseAddCredit}
                className="bg-slate-400 hover:bg-slate-500 text-white font-bold py-2 px-4 rounded"
              >
                {t("common_cancel")}
              </button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </div>
  );
}
